export default{
    site:"https://pc.yz.scallion.top/",
    apiUrl:"https://yz.scallion.top/api"
}


// WEBPACK FOOTER //
// ./src/common/config.js